import React, { useContext } from 'react';
// import { useHistory } from 'react-router-dom';
// import { Dropdown } from '@ikea-ux/dropdown';
// import { DropdownItem } from '@ikea-ux/dropdown';
// import '@ikea-ux/svg-icon/dist/style.css';
// import '@ikea-ux/forms/dist/style.css';
// import '@ikea-ux/inline-text/dist/style.css';
import chevronDown from '@ingka/ssr-icon/paths/chevron-down-small';
// import DropDownController from './DropDownController';
import SSRIcon from '@ingka/ssr-icon';
// import Modal, {
//   Sheets,
//   ModalHeader,
//   ModalFooter,
//   ModalBody
// } from '@ingka/modal';

import '@ingka/svg-icon/dist/style.css';
import '@ingka/forms/dist/style.css';
// import { Select, Option, OptGroup } from '@ingka/select';
// import ListView, { ListViewItem } from "@ingka/list-view";
// import { getPathForLanguage, forOrgAndLang } from '../components/util/language';
// import styled from 'styled-components';
import DataContext from './DataContext/DataContext';
// import theme from './ui/theme';
// import Button from './ui/Button';

// const DropdownStyle = styled.div`
//   appearance: none;
//   -webkit-appearance: none;
//   -moz-appearance: none;

//   width: 20%;
//   font-size: 1rem;
//   font-weight: 400;

//   background: #025ca9;
//   select {
//     width: 100%;
//     color: #fff;
//     outline: none;
//     background: #025ca9;
//     padding: 8px;
//     border: 1px solid #fff;
//     border-radius: 5px;
//     font-size: 1rem;
//     font-weight: 400;
//   }
//   select option {
//     color: #fff;
//     border: none;
//     font-size: 1.4rem;
//     background: #025ca9;
//     padding: 0px;
//   }
// `;

function getSubpath() {
  const segments = window.location.pathname.split('/').slice(4);
  return segments.length === 0 ? '' : `${segments.join('/')}`;
}

const LanguageDropdown = () => {
  const { config, language, setModalOpen, setLanguage } = useContext(DataContext);

  function toggleDropDownHandler(event) {
    setModalOpen(prev => !prev);
    event.preventDefault(); // Prevents default behavior
  }

  const findLangaugeDisplayLabel = languageCode => {
    const languageItem =
      config.languageDisplayLabels &&
      config.languageDisplayLabels.find(
        item => item.languageCode === languageCode
      );
    return languageItem ? languageItem.displayLabel : languageCode;
  };

  if (!config || !config.ifoodPPSILanguageCodes || config.ifoodPPSILanguageCodes.length < 2) {
    return null;
  }

  return (
    <div className="select-container" onClick={event => toggleDropDownHandler(event)}>
      <div className="select-menu">
        <div className="select-btn">
          <div className="select-opt">
            <img className="imageStyle" src={`/${language}.png?v=2`} alt="" />
            <span className="sBtn-text">
              {`${findLangaugeDisplayLabel(language)}`}
            </span>
          </div>
          <SSRIcon style={{ color: '#70757a' }} paths={chevronDown} />
        </div>
      </div>
    </div>
  );
};

export default LanguageDropdown;
